// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  color: #3d4f65;
}

:host .btn {
  border-color: #0066b2;
  color: #ffffff;
  background-color: #0066b2;
}

:host .btn:hover:not(:disabled),
:host .btn:focus-visible:not(:disabled) {
  border-color: #00549c;
  color: #ffffff;
  background-color: #00549c;
}

:host .btn:disabled {
  border-color: #0066b2;
  color: #ffffff;
  background-color: #0066b2;
  opacity: .5;
}

.tokens-heading {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 24px;
}

.provider-kicker,
.summary-label {
  color: #6b7b8f;
  font-size: .72rem;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
}

h1,
h2 {
  color: #1e2a3a;
  font-weight: 700;
}

h2 {
  margin: 6px 0;
  font-size: 1.45rem;
}

.tokens-subtitle {
  color: #6b7b8f;
  font-size: .95rem;
  max-width: 680px;
}

.guide-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.guide-link mat-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
}

.security-note {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-left: 3px solid #0055b3;
  color: #3d4f65;
}

.provider-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.provider-panel {
  min-height: 360px;
  border: 1px solid #e4e9f0;
  border-radius: .5rem;
  overflow: hidden;
  background: #ffffff;
}

.provider-panel--github {
  border-top-color: #0055b3;
}

.provider-panel__header {
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 16px;
  height: 124px;
  box-sizing: border-box;
  padding: 16px 20px;
  border-top: 3px solid #0055b3;
}

.provider-panel__header > div:first-child {
  min-width: 0;
}

.provider-panel__header p {
  margin-bottom: 0;
  color: #6b7b8f;
  line-height: 1.45;
}

.provider-panel > :not(.provider-panel__header) {
  margin-left: 20px;
  margin-right: 20px;
}

.provider-panel > .panel-loading {
  margin-left: 0;
  margin-right: 0;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 6px 10px;
  border: 1px solid #b7d7c1;
  border-radius: 999px;
  color: #28633e;
  background: #f1faf3;
  font-size: .8rem;
  font-weight: 700;
  white-space: nowrap;
}

.status-pill--warning {
  border-color: #e7cd8b;
  color: #8a6011;
  background: #fffaf0;
}

.status-pill--danger {
  border-color: #e2b2b2;
  color: #9f3030;
  background: #fff5f5;
}

.status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
}

.configured-summary {
  display: flex;
  gap: 48px;
  min-height: 58px;
  margin: 34px 0 18px;
  box-sizing: border-box;
  padding: 16px 0;
  border-top: 1px solid #e4e9f0;
  border-bottom: 1px solid #e4e9f0;
}

.configured-summary > div {
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
  white-space: nowrap;
}

.configured-summary .summary-label {
  flex: 0 0 auto;
}

.panel-loading {
  display: grid;
  min-height: 220px;
  place-items: center;
}

.panel-actions,
.form-actions,
.expiry-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.panel-actions {
  flex-wrap: nowrap;
  min-height: 40px;
  margin-top: 34px;
  padding-bottom: 20px;
}

.panel-actions .btn,
.form-actions .btn {
  flex: 0 0 auto;
  white-space: nowrap;
}

.token-form {
  margin-top: 28px;
  padding-top: 22px;
  border-top: 1px solid #e4e9f0;
}

.expiry-row .form-control {
  max-width: 220px;
}

.form-actions {
  justify-content: flex-end;
  padding-bottom: 20px;
}

@media (max-width: 800px) {
  .tokens-heading,
  .provider-panel__header {
    align-items: start;
    flex-direction: column;
  }

  .provider-panel__header {
    height: auto;
    min-height: 124px;
  }

  .provider-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .provider-panel {
    padding: 18px;
  }

  .configured-summary {
    gap: 20px;
    flex-wrap: wrap;
  }

  .configured-summary > div {
    white-space: normal;
  }

  .expiry-row {
    align-items: stretch;
    flex-direction: column;
  }

  .expiry-row .form-control {
    max-width: none;
  }
}
`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/personal-access-tokens/personal-access-tokens.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE;;IAEE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[":host {\n  display: block;\n  color: #3d4f65;\n}\n\n:host .btn {\n  border-color: #0066b2;\n  color: #ffffff;\n  background-color: #0066b2;\n}\n\n:host .btn:hover:not(:disabled),\n:host .btn:focus-visible:not(:disabled) {\n  border-color: #00549c;\n  color: #ffffff;\n  background-color: #00549c;\n}\n\n:host .btn:disabled {\n  border-color: #0066b2;\n  color: #ffffff;\n  background-color: #0066b2;\n  opacity: .5;\n}\n\n.tokens-heading {\n  display: flex;\n  align-items: end;\n  justify-content: space-between;\n  gap: 24px;\n}\n\n.provider-kicker,\n.summary-label {\n  color: #6b7b8f;\n  font-size: .72rem;\n  font-weight: 700;\n  letter-spacing: .08em;\n  text-transform: uppercase;\n}\n\nh1,\nh2 {\n  color: #1e2a3a;\n  font-weight: 700;\n}\n\nh2 {\n  margin: 6px 0;\n  font-size: 1.45rem;\n}\n\n.tokens-subtitle {\n  color: #6b7b8f;\n  font-size: .95rem;\n  max-width: 680px;\n}\n\n.guide-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n}\n\n.guide-link mat-icon {\n  width: 18px;\n  height: 18px;\n  font-size: 18px;\n}\n\n.security-note {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  border-left: 3px solid #0055b3;\n  color: #3d4f65;\n}\n\n.provider-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 20px;\n}\n\n.provider-panel {\n  min-height: 360px;\n  border: 1px solid #e4e9f0;\n  border-radius: .5rem;\n  overflow: hidden;\n  background: #ffffff;\n}\n\n.provider-panel--github {\n  border-top-color: #0055b3;\n}\n\n.provider-panel__header {\n  display: flex;\n  align-items: start;\n  justify-content: space-between;\n  gap: 16px;\n  height: 124px;\n  box-sizing: border-box;\n  padding: 16px 20px;\n  border-top: 3px solid #0055b3;\n}\n\n.provider-panel__header > div:first-child {\n  min-width: 0;\n}\n\n.provider-panel__header p {\n  margin-bottom: 0;\n  color: #6b7b8f;\n  line-height: 1.45;\n}\n\n.provider-panel > :not(.provider-panel__header) {\n  margin-left: 20px;\n  margin-right: 20px;\n}\n\n.provider-panel > .panel-loading {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.status-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 6px 10px;\n  border: 1px solid #b7d7c1;\n  border-radius: 999px;\n  color: #28633e;\n  background: #f1faf3;\n  font-size: .8rem;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.status-pill--warning {\n  border-color: #e7cd8b;\n  color: #8a6011;\n  background: #fffaf0;\n}\n\n.status-pill--danger {\n  border-color: #e2b2b2;\n  color: #9f3030;\n  background: #fff5f5;\n}\n\n.status-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.configured-summary {\n  display: flex;\n  gap: 48px;\n  min-height: 58px;\n  margin: 34px 0 18px;\n  box-sizing: border-box;\n  padding: 16px 0;\n  border-top: 1px solid #e4e9f0;\n  border-bottom: 1px solid #e4e9f0;\n}\n\n.configured-summary > div {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 8px;\n  white-space: nowrap;\n}\n\n.configured-summary .summary-label {\n  flex: 0 0 auto;\n}\n\n.panel-loading {\n  display: grid;\n  min-height: 220px;\n  place-items: center;\n}\n\n.panel-actions,\n.form-actions,\n.expiry-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.panel-actions {\n  flex-wrap: nowrap;\n  min-height: 40px;\n  margin-top: 34px;\n  padding-bottom: 20px;\n}\n\n.panel-actions .btn,\n.form-actions .btn {\n  flex: 0 0 auto;\n  white-space: nowrap;\n}\n\n.token-form {\n  margin-top: 28px;\n  padding-top: 22px;\n  border-top: 1px solid #e4e9f0;\n}\n\n.expiry-row .form-control {\n  max-width: 220px;\n}\n\n.form-actions {\n  justify-content: flex-end;\n  padding-bottom: 20px;\n}\n\n@media (max-width: 800px) {\n  .tokens-heading,\n  .provider-panel__header {\n    align-items: start;\n    flex-direction: column;\n  }\n\n  .provider-panel__header {\n    height: auto;\n    min-height: 124px;\n  }\n\n  .provider-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .provider-panel {\n    padding: 18px;\n  }\n\n  .configured-summary {\n    gap: 20px;\n    flex-wrap: wrap;\n  }\n\n  .configured-summary > div {\n    white-space: normal;\n  }\n\n  .expiry-row {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .expiry-row .form-control {\n    max-width: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
